/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Model_TaskInputs */

const cs_model_task = /** @type {(inputs: Model_TaskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Úkol`)
};

const en_model_task = /** @type {(inputs: Model_TaskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Task`)
};

/**
* | output |
* | --- |
* | "Task" |
*
* @param {Model_TaskInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const model_task = /** @type {((inputs?: Model_TaskInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Model_TaskInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_model_task(inputs)
	return cs_model_task(inputs)
});